export class ComplianceRiskFunktionsebene {
  gesamtesUnternehmen: ComplianceRiskFunktionsebeneUnternehmen;
  funktionenListe: ComplianceRiskFunktionsebeneEntry[];

  constructor() {
    this.gesamtesUnternehmen = new ComplianceRiskFunktionsebeneUnternehmen();
    this.funktionenListe = [];
  }
}

export class ComplianceRiskFunktionsebeneUnternehmen {
  anzahlRisikopaareZuUngunstenMaenner = 0;
  anzahlMaennerMitTieferemLohn = 0;
  anzahlRisikopaareZuUngunstenFrauen = 0;
  anzahlFrauenMitTieferemLohn = 0;
  durchschnittlicheLohnunterschiedeZuUngunstenMaenner = '0%';
  durchschnittlicheLohnunterschiedeZuUngunstenFrauen = '0%';
  risikogewichtZuUngunstenMaenner = 0;
  risikogewichtZuUngunstenFrauen = 0;
  gesamtscore = null;
  variationGesamtscore?: number | string; // TODO remove string wenn Jonathan gefixt hat
  zuUngunstenFrauen?: boolean;
}

export class ComplianceRiskFunktionsebeneEntry extends ComplianceRiskFunktionsebeneUnternehmen {
  funktionId: string;
}
